// src/components/PrivateRoute.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { checkAuth } from "../redux/authSlice";

function PrivateRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, checked } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!checked) {
      dispatch(checkAuth());
    }
  }, [checked, dispatch]);

  if (!checked) {
    return (
      <div className="text-white text-center p-8">
        Checking authentication...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
